import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Typography,
  Autocomplete,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import TaskIcon from "@mui/icons-material/Task";
import BackupIcon from "@mui/icons-material/Backup";
import auth from "../services/auth";
import api from "../services/api";

const Input = styled("input")({
  display: "none",
});

export default function ModalDocumentForm(props) {
  const {
    openDocumentModal,
    handleClose,
    userId,
    creatorId,
    categories,
    setState,
  } = props;
  const [fileName, setFileName] = useState("");
  const [categoryId, setCategoryId] = useState(0);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const name = data.get("title");
    const file = data.get("pdf");
    const formData = new FormData();

    formData.append("path", file);
    formData.append("name", name);
    formData.append("creator_id", creatorId);
    formData.append("user_id", userId);
    formData.append("category_id", categoryId);
    formData.append("status", "sended");

    api
      .post("documents", formData, {
        headers: auth.token(),
      })
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          setState((prev) => !prev);
          handleClose();
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
        }
      });
  };
  const handleFile = (ev) => {
    if (ev.target.files[0]) {
      const name = ev.target.files[0].name;

      setFileName(name);
      return;
    }
    setFileName("");
  };

  return (
    <Dialog
      fullWidth
      component="form"
      maxWidth="sm"
      onSubmit={handleSubmit}
      open={openDocumentModal}
      onClose={handleClose}
    >
      <DialogTitle> Documento</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              autoFocus
              required
              margin="dense"
              id="title"
              name="title"
              label="Título"
              type="text"
              fullWidth
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              sx={{ mt: 1 }}
              disableClearable
              options={categories ? categories : []}
              getOptionLabel={(option) => option.name}
              onChange={(event, category) => setCategoryId(category.id)}
              id="category"
              name="category"
              noOptionsText="Categoria não existente"
              renderInput={(params) => (
                <TextField {...params} label="Categorias" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label htmlFor="pdf">
              <Input
                onChange={handleFile}
                type="file"
                accept="application/pdf, application/vnd.ms-excel"
                name="pdf"
                id="pdf"
              />
              <Button
                required
                component="span"
                variant="contained"
                endIcon={fileName ? <TaskIcon /> : <UploadFileIcon />}
              >
                {fileName ? "Alterar Arquivo" : "Adicionar Arquivo"}
              </Button>
            </label>
          </Grid>
          <Grid item xs={12} sm={6}>
            {categoryId === 0 && (
              <Typography sx={{ color: "failure.main" }}>
                Selecione uma Categoria
              </Typography>
            )}
            <Typography color="primary">{fileName}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={categoryId ? false : true}
          type="submit"
          variant="contained"
          endIcon={<BackupIcon />}
        >
          Enviar
        </Button>
        <Button
          onClick={() => {
            setCategoryId(0);
            handleClose();
          }}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
